import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {LoginComponent} from './pages/login/login.component';
import {SystemUserListingComponent} from './pages/system-user/system-user-list/system-user-list.component';
import {SystemUserDetailComponent} from './pages/system-user/system-user-detail/system-user-detail.component';
import {SystemUserAddComponent} from './pages/system-user/system-user-add/system-user-add.component';
import {SystemUserEditComponent} from './pages/system-user/system-user-edit/system-user-edit.component';
import { UserLayoutComponent } from './shared/components/layouts/user-layout/user-layout.component';
import { BrandsListComponent } from './pages/ecomm/brands/brands-list.component';
import { BrandsAddComponent } from './pages/ecomm/brands/brands-add.component';
import { BrandsDetailComponent } from './pages/ecomm/brands/brands-detail.component';
import { ProductsListComponent } from './pages/ecomm/products/products-list.component';
import { ProductsAddComponent } from './pages/ecomm/products/products-add.component';
import { ProductsDetailComponent } from './pages/ecomm/products/products-detail.component';
import { DiscountsListComponent } from './pages/ecomm/discounts/discounts-list.component';
import { DiscountsAddComponent } from './pages/ecomm/discounts/discounts-add.component';
import { DiscountsDetailComponent } from './pages/ecomm/discounts/discounts-detail.component';
import { CorporateDealsListComponent } from './pages/ecomm/corporate-deals/corporate-deals-list.component';
import { CorporateDealsAddComponent } from './pages/ecomm/corporate-deals/corporate-deals-add.component';
import { CorporateDealsDetailComponent } from './pages/ecomm/corporate-deals/corporate-deals-detail.component';
import { AddOnsListComponent } from './pages/ecomm/add-ons/add-ons-list.component';
import { AddOnsAddComponent } from './pages/ecomm/add-ons/add-ons-add.component';
import { AddOnsDetailComponent } from './pages/ecomm/add-ons/add-ons-detail.component';
import { CategoriesListComponent } from './pages/ecomm/categories/categories-list.component';
import { CategoriesAddComponent } from './pages/ecomm/categories/categories-add.component';
import { CategoriesDetailComponent } from './pages/ecomm/categories/categories-detail.component';
import { SapCategoriesListComponent } from './pages/ecomm/sap-categories/sap-categories-list.component';
import { SapCategoriesAddComponent } from './pages/ecomm/sap-categories/sap-categories-add.component';
import { SapCategoriesDetailComponent } from './pages/ecomm/sap-categories/sap-categories-detail.component';

const PRIVATE_ROUTES: Routes = [
  {path: '', component: DashboardComponent},
];
const routes: Routes = [
  // {path: '', component: IndexComponent, children: PRIVATE_ROUTES, canActivate: [AuthGuard]},
  {path: 'login', component: LoginComponent},

  {
    path: '',
    component: UserLayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'system-user/list', component: SystemUserListingComponent },
      { path: 'system-user/add', component: SystemUserAddComponent },
      { path: 'system-user/details/:id', component: SystemUserDetailComponent },
      { path: 'system-user/edit/:id', component: SystemUserEditComponent },
      { path: 'ecomm/brands', component: BrandsListComponent },
      { path: 'ecomm/brands/add', component: BrandsAddComponent },
      { path: 'ecomm/brands/:id', component: BrandsDetailComponent },
      { path: 'ecomm/categories', component: CategoriesListComponent },
      { path: 'ecomm/categories/add', component: CategoriesAddComponent },
      { path: 'ecomm/categories/:id', component: CategoriesDetailComponent },
      { path: 'ecomm/sap-categories', component: SapCategoriesListComponent },
      { path: 'ecomm/sap-categories/add', component: SapCategoriesAddComponent },
      { path: 'ecomm/sap-categories/:id', component: SapCategoriesDetailComponent },
      { path: 'ecomm/products', component: ProductsListComponent },
      { path: 'ecomm/products/add', component: ProductsAddComponent },
      { path: 'ecomm/products/:id', component: ProductsDetailComponent },
      { path: 'ecomm/discounts', component: DiscountsListComponent },
      { path: 'ecomm/discounts/add', component: DiscountsAddComponent },
      { path: 'ecomm/discounts/:id', component: DiscountsDetailComponent },
      { path: 'ecomm/corporate-deals', component: CorporateDealsListComponent },
      { path: 'ecomm/corporate-deals/add', component: CorporateDealsAddComponent },
      { path: 'ecomm/corporate-deals/:id', component: CorporateDealsDetailComponent },
      { path: 'ecomm/add-ons', component: AddOnsListComponent },
      { path: 'ecomm/add-ons/add', component: AddOnsAddComponent },
      { path: 'ecomm/add-ons/:id', component: AddOnsDetailComponent },
    ],
  },

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
